const React = require("react");
const DashboardBlockField = require("../../../DashboardBlockField");

module.exports = ({value, label}) => (
  <DashboardBlockField
    label={label}
    className={`
      (ttU)>.ref-field__label
      (h84|jcC|aiC|ph13|f30|fw7)>.ref-field__block
    `}
  >
    {value}
  </DashboardBlockField>
)